var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocTypeVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill: #006b87;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,26C5.8,26,0,20.2,0,13S5.8,0,13,0s13,5.8,13,13-5.8,13-13,13ZM13,2C6.9,2,2,6.9,2,13s4.9,11,11,11,11-4.9,11-11S19.1,2,13,2ZM10.3,16.9l-3.8-3.8-1.3,1.3,5.1,5.1,10.9-10.9-1.3-1.3-9.6,9.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocTypeVerify);
export default __webpack_public_path__ + "static/media/Icon_DocType_Verify.31dc680f28e5578d759cb9d2c899cf82.svg";
export { ForwardRef as ReactComponent };